export default [
  {
    key: 'increasement',
    sortable: true,
    sortField: 'createdAt',
  label: 'label.no',
    thClass: 'w-50px',
  },
  {
    key: 'date',
    sortable: true,
    sortField: 'date',
    label: 'field.date',
    stickyColumn: true,
    variant: 'light',
    thClass: 'text-left',
    tdClass: 'text-left',
  },
  {
    key: '1Rate',
    label: 'field.1Rate',
  },
  {
    key: '2Rate',
    label: 'field.2Rate',
  },
  {
    key: '3Rate',
    label: 'field.3Rate',
  },
  {
    key: '4Rate',
    label: 'field.4Rate',
  },
  {
    key: '5Rate',
    label: 'field.5Rate',
  },
];
